export default __webpack_public_path__ + "static/media/angels_welcome_market.0024cc23.png";